export default function config (state = {}, action) {
    switch (action.type) {
        case 'SET_CONFIG':
            return {
                ...state,
                config: action.config
            };
        case 'SET_SUBDOMAIN':
            return {
                ...state,
                subdomain: action.subdomain
            }
        case 'SET_THEME':
            return {
                ...state,
                theme: action.theme
            };
        case 'START_LOADER':
            return {
                ...state,
                loaderStatus: action.loaderStatus
            }
        case 'STOP_LOADER':
            return {
                ...state,
                loaderStatus: action.loaderStatus
            }
        case 'SET_BREADCRUMBS':
            return {
                ...state,
                breadcrumbs: Object.assign([], action.breadcrumbs)
            }
        case 'SET_CURRENT_COUNTRY_CODE':
            return {
                ...state,
                currentCountryCode: action.currentCountryCode
            }
        default:
            return state;
    }
}